import React from "react";
import { motion } from "framer-motion";
import { useScrollReveal } from "../hooks/useScrollReveal";

// Shared scroll-reveal: fades/slides content in as it scrolls into view and
// reverses cleanly on scroll-up. Use `delay` to stagger siblings (~0.1 apart).
const Reveal = ({ children, delay = 0, y = 40, className }) => {
  const { ref, opacity, offset } = useScrollReveal({ delay, distance: y, axis: "y" });
  return (
    <motion.div ref={ref} className={className} style={{ opacity, y: offset }}>
      {children}
    </motion.div>
  );
};

export default Reveal;
